import React from 'react';
import Leave_Approv from './Leave_Approv';
import '../../CommonCSS/SocietyCSS.css'


const Leave_ApprovApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Student Leave Application</h5>
          </div>  
        </div>
        <Leave_Approv/>
      </div>
    </div >
  );
};

export default Leave_ApprovApp;
